import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GenericListEntity, BaseEntitiesResponse, BaseEntityResponse } from "@base/entities/BaseEntities";
import { APIGatewayService } from "../gateway/APIGateway.service";
import { BaseEndpoint } from "@base/endpoint/BaseEndpoint";
import { DataLoadOptions } from "@base/datalayer/DataLoadOptions";

@Injectable()
export class GenericListEndpoint extends BaseEndpoint  
{
    public constructor(api: APIGatewayService)
    {
        super("GenericList", api);
    }


    public GetList(DataSourceName: string, options?: DataLoadOptions): Observable<BaseEntitiesResponse<GenericListEntity>>
    {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetList', options ? { ...{ DataSourceName: DataSourceName }, ...options.GetLoadOptions() } : {DataSourceName:DataSourceName});
    }
    
    public GetByValue(DataSourceName: string, Value: string): Observable<BaseEntityResponse<GenericListEntity>>
    {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetByValue', { DataSourceName: DataSourceName, Value: Value });
    }
}
